import { alpha, Avatar, Box, Button, Card, CardActionArea, CardContent, Grid, Icon, IconButton, ListItem, ListItemAvatar, ListItemText, Paper, styled, Typography } from "@mui/material"
import React, { useState } from "react"
import { DayDispo, HoursDisponibilty } from "../../../shared/constants/Days";
import { BASE_COLOR } from "../../../shared/constants/color.constant";
import { Close } from "@mui/icons-material";
import SvgAllDay from "../../../icons/SvgAllDay";
import SvgMidi from "../../../icons/SvgMidi";
import SvgNight from "../../../icons/SvgNight";
import SvgSoiree from "../../../icons/SvgSoiree";
import SvgAfternoon from "../../../icons/SvgAfternoon";
import Svg24H from "../../../icons/Svg24H";
import SvgMorning from "../../../icons/SvgMorning";
import SvgIndisponible from "../../../icons/SvgIndisponible";

export interface Disponibility {
    _id: any,
    label: string,
    value: string,
    day: string
}

export const modifDisponibilityPeriod = (disponibilities: Disponibility[], dayValue: string, dayPeriod: string) => {
    console.log(`Disponibilities before modif: \n ${JSON.stringify(disponibilities)}`)

    for (let i = 0; i<disponibilities.length; i++) {
        if (disponibilities[i].value === dayValue) {
            disponibilities[i].day = dayPeriod;
            break;
        }
    }

    console.log(`Disponibilities after modif: \n ${JSON.stringify(disponibilities)}`)
}

const getDisponibilityIcon = (value: string) => {
    let icon = <SvgAllDay />

    if (value === HoursDisponibilty.JOURNE) {
        icon = <SvgAllDay />
    } else if (value === HoursDisponibilty.MIDI) {
        icon = <SvgMidi />
    } else if (value === HoursDisponibilty.NUIT) {
        icon = <SvgNight />
    } else if (value === HoursDisponibilty.SOIR) {
        icon = <SvgSoiree />
    } else if (value === HoursDisponibilty.APRESMIDI) {
        icon = <SvgAfternoon />
    } else if (value === HoursDisponibilty.ALL) {
        icon = <Svg24H />
    } else if (value === HoursDisponibilty.MATIN) {
        icon = <SvgMorning />
    } else if (value === HoursDisponibilty.INDISPONIBLE) {
        icon = <SvgIndisponible />
    }
    
    return icon
}

export const DisponibilityCard: React.FC<{
    disponibility: Disponibility;
    isActive: boolean;
    onClickCard: (day: string, value: string) => void;
}> = ({ 
    disponibility,
    isActive,
    onClickCard 
}) => {
    

    console.log(`Disponibility Item: ${JSON.stringify(disponibility)}`)

    const disponibilityPeriodeLabel = DayDispo(disponibility.day)

    return (
        <Card
            onClick={() => {
                onClickCard(disponibility.day, disponibility.value)
            }}
            sx={{
                borderRadius: 2, 
                height: 50,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: isActive ? BASE_COLOR.PRIMARY : BASE_COLOR.WHITE,
                cursor: 'pointer',
                transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                    backgroundColor: alpha(BASE_COLOR.PRIMARY, 0.4),
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)'
                }
            }}
        >
            <CardContent
                sx={{
                    paddingTop: '25px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    overflow: 'hidden',
                }}
            >
                <Typography 
                    variant="body2" 
                    fontWeight="bold"
                    color={ isActive ? BASE_COLOR.WHITE : BASE_COLOR.DARK }
                    sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                    {disponibility.label}
                </Typography>
                <Typography 
                    variant="caption"
                    color={ isActive ? "lightgrey" : "grey" }
                    sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                    {disponibilityPeriodeLabel}
                </Typography>
            </CardContent>
        </Card>
    )
}

export const DisponibilityContainer: React.FC<{
    disponibilities: Disponibility[];
    onClickCard: (day: string, value: string) => void;
    clickedValue: string;
}> = ({ 
    disponibilities,
    onClickCard,
    clickedValue
}) => {
    console.log(`Disponibilities de l'user dans le Drawer: ${JSON.stringify(disponibilities)}`)

    const handleCardClick = (day: string, value: string) => {
        onClickCard(day, value)
    }

    return (
        <Grid 
            item
            sx={{
                width: '100%'
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(min(200px, 100%), 1fr))',
                    gap: 2,
                }}
            >
                {disponibilities.map((element) => (
                    <DisponibilityCard
                        key={element.value}
                        disponibility={element}
                        onClickCard={handleCardClick}
                        isActive={clickedValue?.trim() === element.value.trim()}
                    />
                ))}
            </Box>
        </Grid>
    )
}

export const DisponibilityPeriodeCard: React.FC<{
    periode: string;
    onClickPeriode: (newPeriode: string) => void;
    isSelected: boolean
}> = ({
    periode,
    onClickPeriode,
    isSelected
}) => {
    const periodeLabel = DayDispo(periode)

    const selectedBackColor = BASE_COLOR.PRIMARY
    const hoveredBackColor = alpha(BASE_COLOR.PRIMARY, 0.3)
    const unhoveredBackColor = BASE_COLOR.WHITE

    return (
        <ListItem 
            sx={{
                cursor: 'pointer',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'lightgrey',
                backgroundColor: isSelected ? BASE_COLOR.PRIMARY : unhoveredBackColor,
                transition: 'borderColor 0.3 ease, background-color 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                    borderRadius: 2,
                    border: '2px solid',
                    borderColor: BASE_COLOR.PRIMARY,
                    backgroundColor: isSelected ? selectedBackColor : hoveredBackColor,
                    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.2)'
                }
            }}
            onClick={() => onClickPeriode(periode)}
        >
            <ListItemAvatar>
                <Avatar>
                    <Icon>
                        {getDisponibilityIcon(periode)}
                    </Icon>
                </Avatar>
            </ListItemAvatar>
            <ListItemText 
                sx={{
                    color: isSelected ? BASE_COLOR.WHITE : 'black'
                }}
                primary={periodeLabel}
            />
      </ListItem>
    )
}

export const DisponibilityPeriodeContainer: React.FC<{
    currentDayDisponibility: string;
    clickedDispoValue: string;
    onCloseContainer: () => void;
    onChangeDisponibility: (periode: string) => void;
}> = ({
    currentDayDisponibility,
    clickedDispoValue,
    onCloseContainer,
    onChangeDisponibility
}) => {

    console.log(`Current day disponibility: ${currentDayDisponibility}`)
    const [tempPeriode, setTempPeriode] = useState(currentDayDisponibility)

    const choixPeriodes: string[] = [
        HoursDisponibilty.MATIN,
        HoursDisponibilty.MIDI,
        HoursDisponibilty.APRESMIDI,
        HoursDisponibilty.SOIR,
        HoursDisponibilty.JOURNE,
        HoursDisponibilty.NUIT,
        HoursDisponibilty.ALL,
        HoursDisponibilty.INDISPONIBLE
    ]

    return (
        <Card 
            sx={{
                padding: 2,
                borderRadius: 2,
                border: '2px solid',
                borderColor: BASE_COLOR.PRIMARY
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 2, // Ajout d'espace blanc avant la box
                }}
            >
                <Typography 
                    variant="body2" 
                    component="div" 
                    fontWeight="bold"
                    color={BASE_COLOR.PRIMARY}
                >
                    Choisir une période pour {clickedDispoValue}
                </Typography>
                <IconButton 
                    size="small" 
                    onClick={onCloseContainer} // Remplacez par une action réelle si nécessaire
                >
                    <Close />
                </IconButton>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(min(200px, 100%), 1fr))',
                    gap: 2,
                }}
            >
                {choixPeriodes.map((periode) => (
                    <DisponibilityPeriodeCard
                        periode={periode}
                        onClickPeriode={(newPeriode) => {
                            setTempPeriode(newPeriode)
                            console.log(`Current selected Periode: ${tempPeriode}`)
                        }}
                        isSelected={periode === tempPeriode}
                    />
                ))}
            </Box>
            <div className="flex justify-center flex-col align-center">
                <div className="my-5 flex justify-center gap-2">
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => onChangeDisponibility(tempPeriode)}
                    >
                        Confirmer
                    </Button>
                </div>
            </div>
        </Card>
    )
}